import React, { Component } from "react";
import { Container, Row, Col, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
//import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "components/Button/Button";
//import RUG from "react-upload-gallery";
import PlacesAutocomplete from "react-places-autocomplete";
import {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";
// import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import './style.css';
// import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner'
let street_num='';let route_num='';

class NewVenue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      venue_info: props.venue_info,
      validated: false,
    };
    
    if (!this.state.venue_info.venue_type) {
      //this.state.venue_info.venue_type = 'physical';
      this.state.venue_info.venue_type = 'virtual';
    }

    // so we don't try to patch things like 'created_time', etc.
    this.editable_properties = {
      entity_uuid: true,
      entity_name: true,
      street: true,
      city_name: true,
      state_province: true,
      postal_code: true,
      country: true,
      phone: true,
      website_url: true,
      ticketing_url: true,
      coordinates_lat: 'number',
      coordinates_lon: 'number',
      max_capacity: 'number',
      description: true,
      venue_type: true,
      virtual_meeting_link: true,
      virtual_meeting_id: true,
      virtual_meeting_password: true,
    }
  }
  
  componentDidMount() {
    // if this is add, remove '(None)' as entity_name
    let tmp_venue_info = {...this.props.venue_info};
    if (!this.props.venue_info.entity_uuid) {
      tmp_venue_info.entity_name = '';
    }
    
    this.setState({
      venue_info: tmp_venue_info
    });
    
  }
  
  // Form data handler started
  myChangeHandler = (event) => {

    let tmp_venue_info = {...this.state.venue_info};

    if (event.target.min && event.target.max && event.target.value) {
      event.target.value = Math.max(Number(event.target.min), Math.min(Number(event.target.max), Number(event.target.value)));
    }
    
    tmp_venue_info[event.target.id] = event.target.value;
    
    this.setState({
      venue_info: tmp_venue_info
    })
    

  };

  cancelSaveVenue = () => {
    //event.preventDefault();
    //event.stopPropagation();
    this.props.onSaveVenue(false);
  }

  onSaveVenue = (event) => {
    //console.log("AddNewVenueV2 onSaveVenue 1",this.state.venue_info);

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
        console.log("FORM INVALID");
        event.preventDefault();
        event.stopPropagation();
        this.setState({ validated: true });
        window.scrollTo(0,50);
        return;
    }
    
    console.log("FORM VALID",this.state.validated);

    // filter out non-editable properties
    let tmp_venue_info = {...this.state.venue_info};
    
    for (let venue_property of Object.keys(this.state.venue_info)) {
      if (!this.editable_properties[venue_property]) {
        delete tmp_venue_info[venue_property];
      } else if (this.editable_properties[venue_property] === 'number') {
        if (tmp_venue_info[venue_property] === "") {
          // don't send empty string for number field - just don't send attribute at all
          delete tmp_venue_info[venue_property];  
        }
      }
    }
    
    console.log("AddNewVenueV2 onSaveVenue",tmp_venue_info);
    this.props.onSaveVenue(tmp_venue_info);
  }


  
  handlePlacesChange = (places_name) => {
    let tmp_venue_info = {...this.state.venue_info}
    tmp_venue_info.entity_name = places_name;
    if (places_name.length <= 1) {
      // clear other fields
      tmp_venue_info = {
        ...tmp_venue_info,
        coordinates_lat: '',
        coordinates_lon: '',
        street: '',
        city_name: '',
        state_province: '',
        postal_code: '',
        country: ''
      }
    }
    this.setState({
      venue_info: tmp_venue_info
    });


  };

  handlePlacesSelect = async (places_name) => {
    let tmp_venue_info = {...this.state.venue_info}
    let tmp_venue_name_array = places_name.split(","); // data returned from google is long - first part is good
    tmp_venue_info.entity_name = tmp_venue_name_array[0];

    // google API magic
    let geocodeByAddress_results = await geocodeByAddress (places_name);
    let latLng = await getLatLng(geocodeByAddress_results[0]);
    tmp_venue_info.coordinates_lat = latLng.lat;
    tmp_venue_info.coordinates_lon = latLng.lng;
    
    let tmp_street_obj = {
      street_number: '',
      street_name: ''
    };
    for (let item of geocodeByAddress_results[0].address_components) {
      if (item.types) {
        for (let type of item.types) {
          if (type === 'street_number') {
            tmp_street_obj.street_number = item.long_name; // will combine this with 
          } else if (type === 'route') {
            tmp_street_obj.street_name = item.long_name; // this is actually street name
          } else if (type === 'locality') {
            tmp_venue_info.city_name = item.long_name;
          } else if (type === 'administrative_area_level_1') {
            tmp_venue_info.state_province = item.long_name;
          } else if (type === 'postal_code') {
            tmp_venue_info.postal_code = item.long_name;
          } else if (type === 'country') {
            tmp_venue_info.country = item.long_name;
          }
        }
      }
    }
    tmp_venue_info.street = tmp_street_obj.street_number+' '+tmp_street_obj.street_name;
    
    this.setState({
      venue_info: tmp_venue_info
    });
    
  }


  handleVenueTypeChange = (venue_type) => {
    console.log("handleVenueTypeChange",venue_type);
    
    this.setState({
      venue_info: {
        ...this.state.venue_info,
        venue_type
      }
    })
    
  }

  render() {
    //console.log("RENDER",this.state.venue_info.venue_type)
    return (
      <Container>
        <Row style={{ marginTop: "15px", marginBottom: "5px" }} className="">
          <Col lg={4} className="">
            <h1>{this.state.venue_info.entity_uuid ? "Edit Venue" : "Create Venue"}</h1>
          </Col>
          <Col lg={4} className="">
            <ToggleButtonGroup
              style={{ height: "80%" }}
              type="radio"
              name="venue_type"
              value={this.state.venue_info.venue_type}
              onChange={this.handleVenueTypeChange}
            >
              <ToggleButton
                variant="outline-secondary"
                style={{ textTransform: 'none', whiteSpace: "nowrap" }}
                //className="Btn-Blue-BG"
                name="venue_type"
                value={'virtual'}
                disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
              >
                Virtual Meeting
              </ToggleButton>
              <ToggleButton
                variant="outline-secondary"
                style={{ textTransform: 'none', whiteSpace: "nowrap" }}
                //className="Btn-Blue-BG"
                name="venue_type"
                value={'physical'}
                disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
              >
                Physical Location
              </ToggleButton>
            </ToggleButtonGroup>
          </Col>
        </Row>
        <Row className="">
          <Col lg={8} className="coverphoto">
            <Form noValidate validated={this.state.validated} onSubmit={this.onSaveVenue}>
              { (this.state.venue_info.entity_uuid || this.state.venue_info.venue_type === 'virtual') ?
                // edit - do not use places API
                <div>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="entity_name">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      required
                      minLength={3}
                      type="text"
                      value={this.state.venue_info.entity_name || ''}
                      placeholder={this.state.venue_info.venut_type === 'physical' ? "(REQUIRED) Example: Wrigley Field" : "(REQUIRED) Example: My Team Zoom"}
                      onChange={this.myChangeHandler}
                    />
                    <Form.Control.Feedback type="invalid">
                        Please enter a name at least 3 characters long
                    </Form.Control.Feedback>
                  </Form.Group>
                </Form.Row> 
                </div>
                :
                // Create - using places API
                <PlacesAutocomplete
                  value={this.state.venue_info.entity_name}
                  onChange={this.handlePlacesChange}
                  onSelect={this.handlePlacesSelect}
                >
                  {({
                    getInputProps,
                    suggestions,
                    getSuggestionItemProps,
                    loading
                  }) => (
                      <div>
                        <Form.Row>
                          <Form.Group as={Col} md="12" controlId="entity_name">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                              disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                              required
                              type="text"
                              //pattern=".{3,}"
                              minLength={3}
                              value={this.state.venue_info.entity_name || ''}
                              placeholder="(REQUIRED) Example: Wrigley Field"
                              onChange={this.myChangeHandler}
                              {...getInputProps({
                                placeholder: "(REQUIRED) Example: Wrigley Field",
                                className: "location-search-input"
                              })}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please enter a name at least 3 characters long
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Form.Row>
                        <div>
                          <div className="autocomplete-dropdown-container">
                            {loading && <div className="loadingSearchData">Loading...</div>}
                            {suggestions.map(suggestion => {
                              const className = suggestion.active
                                ? "suggestion-item--active"
                                : "suggestion-item";
                              // inline style for demonstration purpose
                              const style = suggestion.active
                                ? { backgroundColor: "#fafafa", cursor: "pointer" }
                                : { backgroundColor: "#ffffff", cursor: "pointer" };
                              return (
                                <div
                                  {...getSuggestionItemProps(suggestion, {
                                    className,
                                    style
                                  })}
                                >
                                  <span>{suggestion.description}</span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    )}
                </PlacesAutocomplete>
              }

              { this.state.venue_info.venue_type === 'physical' &&
              <React.Fragment>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="street">
                    <Form.Label>Street</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      type="text"
                      value={this.state.venue_info.street || ''}
                      placeholder="Example: 1060 West Addison Street"
                      onChange={this.myChangeHandler}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="city_name">
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      type="text"
                      placeholder="Example: Chicago"
                      value={this.state.venue_info.city_name || ''}
                      onChange={this.myChangeHandler}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="state_province">
                    <Form.Label>State/Province</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      type="text"
                      placeholder="Example: IL"
                      value={this.state.venue_info.state_province || ''}
                      onChange={this.myChangeHandler}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="postal_code">
                    <Form.Label>Postal Code</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      type="text"
                      value={this.state.venue_info.postal_code || ''}
                      placeholder="Example: 60613"
                      onChange={this.myChangeHandler}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="country">
                    <Form.Label>Country</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      type="text"
                      value={this.state.venue_info.country || ''}
                      placeholder="Example: USA"
                      onChange={this.myChangeHandler}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="phone">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      type="string"
                      placeholder="Example: +1 7734042827"
                      value={this.state.venue_info.phone || ''}
                      onChange={this.myChangeHandler}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="website_url">
                    <Form.Label>Website URL</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      type="text"
                      value={this.state.venue_info.website_url || ''}
                      onChange={this.myChangeHandler}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="ticketing_url">
                    <Form.Label>Ticketing URL</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      type="text"
                      value={this.state.venue_info.ticketing_url || ''}
                      onChange={this.myChangeHandler}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="coordinates_lat">
                    <Form.Label>Coordinates Latitude</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      type="number"
                      value={this.state.venue_info.coordinates_lat || ''}
                      onChange={this.myChangeHandler}
                      min="-90"
                      max="90"
                      step="any"
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="coordinates_lon">
                    <Form.Label>Coordinates Longitude</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      type="number"
                      value={this.state.venue_info.coordinates_lon || ''}
                      onChange={this.myChangeHandler}
                      min="-180"
                      max="180"
                      step="any"
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="max_capacity">
                    <Form.Label>Max. Capacity</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      type="number"
                      value={this.state.venue_info.max_capacity || ''}
                      onChange={this.myChangeHandler}
                      min="0"
                      max="10000000"
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="description">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      //required
                      type="text"
                      value={this.state.venue_info['description'] || ''}
                      onChange={this.myChangeHandler}
                    />
                  </Form.Group>
                </Form.Row>
              </React.Fragment>
              }
              
              { this.state.venue_info.venue_type === 'virtual' &&
              <React.Fragment>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="virtual_meeting_link">
                    <Form.Label>Virtual Meeting Link URL</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      type="string"
                      placeholder="Example: https://zoom.us/j/9999999999"
                      value={this.state.venue_info.virtual_meeting_link || ''}
                      onChange={this.myChangeHandler}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="virtual_meeting_id">
                    <Form.Label>Virtual Meeting ID</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      type="string"
                      placeholder="Example: 9999999999"
                      value={this.state.venue_info.virtual_meeting_id || ''}
                      onChange={this.myChangeHandler}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="virtual_meeting_password">
                    <Form.Label>Virtual Meeting Password</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      type="string"
                      placeholder="Example: 1234z"
                      value={this.state.venue_info.virtual_meeting_password || ''}
                      onChange={this.myChangeHandler}
                    />
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="phone">
                    <Form.Label>Call-in phone number</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      type="string"
                      placeholder="Example: +1 7734042827"
                      value={this.state.venue_info.phone || ''}
                      onChange={this.myChangeHandler}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="description">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      disabled={'editable' in this.state.venue_info && this.state.venue_info.editable === false}
                      //required
                      type="text"
                      value={this.state.venue_info['description'] || ''}
                      onChange={this.myChangeHandler}
                    />
                  </Form.Group>
                </Form.Row>
              </React.Fragment>
              }
              
              { (!('editable' in this.state.venue_info) || this.state.venue_info.editable === true) &&
                <Button theme="btn-global btn-hover btn-green HomePage-btn" type="submit">
                  {this.state.venue_info.entity_uuid ? "Save Venue" : "Create Venue"}
                </Button>
              }
              <Button style={{ marginLeft: "10px" }} theme="btn-global btn-hover btn-grey HomePage-btn" OnClickMet={() => this.cancelSaveVenue()}>
                {(!('editable' in this.state.venue_info) || this.state.venue_info.editable === true) ? 'Cancel' : 'Back'}
              </Button>
            {/* </Form> */}
            </Form>
          </Col>
        </Row>
      </Container>
    );
  
  }
}

export default NewVenue;
